<script setup>
import { computed } from 'vue';
import { MESSAGE_STATUS, MESSAGE_TYPES } from '../../constants';
import { useMessageContext } from '../../provider.js';
import { messageTimestamp, dynamicTime } from 'shared/helpers/timeHelper';

const { contentAttributes, status, sender, createdAt, messageType } = useMessageContext();

const hasError = computed(() => {
  return status.value === MESSAGE_STATUS.FAILED;
});

const isIncoming = computed(() => messageType.value === MESSAGE_TYPES.INCOMING);

const fromEmail = computed(() => {
  return contentAttributes.value?.email?.from ?? [];
});

const displaySenderName = computed(() => {
  const fromEmailAddress = fromEmail.value[0] ?? '';
  const senderEmail = sender.value?.email ?? '';

  if (isIncoming.value) {
    if (sender.value?.name) return sender.value.name;
    if (fromEmailAddress) return fromEmailAddress;
  } else {
    // For outgoing emails sent by agent
    if (sender.value?.name) return sender.value.name;
    if (fromEmailAddress === senderEmail && sender.value?.name) {
      return sender.value.name;
    }
  }
  return 'Unknown Sender';
});

const displaySenderEmail = computed(() => {
  if (isIncoming.value) {
    return fromEmail.value[0] || sender.value?.email || '';
  } else {
    return sender.value?.email || fromEmail.value[0] || '';
  }
});

const absoluteTime = computed(() => messageTimestamp(createdAt.value, 'dd MMM yyyy, hh:mm a'));
const relativeTime = computed(() => dynamicTime(createdAt.value));

</script>

<template>
  <section
    class="flex justify-between items-start text-sm w-full"
    :class="hasError ? 'text-n-ruby-11' : 'text-n-slate-12'"
  >
    <div class="flex flex-col gap-0.5">
      <span class="font-medium text-heading-3">{{ displaySenderName }}</span>
      <span v-if="displaySenderEmail" class="text-n-slate-11 text-xs">{{ displaySenderEmail }}</span>
    </div>
    
    <div class="flex flex-col items-end gap-0.5">
      <span class="text-n-slate-12 font-medium capitalize">{{ relativeTime }}</span>
      <span class="text-n-slate-11 text-xs">{{ absoluteTime }}</span>
    </div>
  </section>
</template>
